import { ChangeDetectorRef, Component, HostListener, OnInit } from '@angular/core';
import { FuseConfigService } from '@fuse/services/config.service';
import { AspQuotationDetailsService } from './asp-quotation-details.service';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-asp-quotation-details',
  templateUrl: './asp-quotation-details.component.html',
  styleUrls: ['./asp-quotation-details.component.scss']
})
export class AspQuotationDetailsComponent implements OnInit {
  quoteId: any;
  jobId: any;
  quoteDetails: any = [];
  quoteReceivedDetails: any = [];
  quoteApprovedDetails: any = [];
  quoteReceivedTotal: number = 0;
  quoteApprovedTotal: number = 0;
  selectAllQuote:boolean = false;
  isActiveApprove:boolean = false;
  quoteReceivedSelectedTotal: number = 0;
  quoteReceivedSelectedCount: number = 0;
  isActiveComplete:boolean = false;
  isPopupOpen: boolean = false;
  successIcon:string = '../../../../assets/icons/icons8-ok.gif';
  make:any;
  model:any;
  fuelType:any;
  makeImg: string;
  registrationNo: string;
  activeTabIndex: number = 0;
  data: any;
  updatedImages: any;
  quotationImages: any[];
  quotationImagesLength: any;
  isViewerOpen: boolean = false;
  currentIndex = 0;
  currentTag: string = '';
  selectedImage: any;
  deleteUpdatedImage: any[];
  quoteReceivedPartsCount: number = 0;
  quoteReceivedLabourCount: number = 0;
  showExtraDiscountBottomSheet = false;
  discountType: 'rupees' | 'percentage' | null;
  discountValue: number | null | 0.0;
  showInfoPopup: boolean = false;
  discountInRupees: number = 0;
  discountInPercent: number = 0;
  calculatedDiscount: number = 0;
  getDiscount: any;
  isDiscountInvalid: boolean;
  garageKey: string;
  userKey: string;

  constructor(
    private route: ActivatedRoute,
    private _fuseConfigService: FuseConfigService,
    private aspQuotationDetailsService: AspQuotationDetailsService,
    private cdr: ChangeDetectorRef
  ) { }

  ngOnInit(): void {
    this._fuseConfigService.config = {
      layout: {
        navbar: { hidden: true },
        toolbar: { hidden: true },
        footer: { hidden: true },
        sidepanel: { hidden: true }
      }
    };
    this.route.paramMap.subscribe(params => {
      const encoded = params.get('encoded');
      if (encoded) {
        try {
          const decoded = atob(encoded); // Base64 decode
          const [quoteId, jobId, garageKey, userKey] = decoded.split('/');
  
          this.quoteId = quoteId;
          this.jobId = jobId;
          this.garageKey = garageKey;
          this.userKey=userKey;
        } catch (error) {
          console.error('Invalid encoded URL format', error);
        }
      }
    });

    this.getQuoteDetails();
    this.getQuoteReceivedDetails();

  }

  getQuoteDetails() {
    this.quoteDetails = [];
    this.quoteReceivedDetails = [];
    this.quoteApprovedDetails = [];
  
    this.aspQuotationDetailsService.getQuoteDetails(this.garageKey, this.quoteId, this.jobId, this.userKey).subscribe(
      result => {
        const res = JSON.parse(JSON.stringify(result));console.log(res)
        this.quoteDetails = res.data;
        console.log('Quote Details --',this.quoteDetails)

        this.quotationImages = Array.isArray(this.quoteDetails.quotationImages) ? this.quoteDetails.quotationImages : [];

        console.log("quotation-images----,",this.quotationImages);
        
        this.quotationImagesLength = this.quotationImages.length;

        if(this.quoteDetails.make){
          const makeWithoutSpaces = this.quoteDetails.make.toLowerCase().replace(/\s+/g, '');
          this.makeImg =  `https://cube.getpitstop.com/assets/img/${makeWithoutSpaces}.png`;
          this.make = this.quoteDetails.make;
        }

        if(this.quoteDetails.model){
          this.model = this.quoteDetails.model;
        }

        if(this.quoteDetails.fuelType){
          this.fuelType = this.quoteDetails.fuelType;
        }

        if(this.quoteDetails.registrationNo){
          this.registrationNo = this.quoteDetails.registrationNo;
        }
        
        this.getQuoteReceivedDetails();
        this.getQuoteApprovedDetails();
      },
      error => {
        console.error('Error fetching quote details:', error);
      }
    );
  }

  getQuoteReceivedDetails(){
    // console.log("this.quotedetails---",this.quoteDetails);
    // console.log("this.quote details of jobcardstatus---",this.quoteDetails.items.jobCardStatus);
    this.quoteDetails?.items?.forEach(received => {
      if(received.jobCardStatus==3){
        received.type = "parts";
        received.checked = false;
        this.quoteReceivedDetails.push(received);
        this.quoteReceivedTotal +=  (received.sellingPrice*received.quantity);
        this.quoteReceivedPartsCount = this.quoteReceivedPartsCount+1;
      }
    });

    this.quoteDetails?.labourQuoteItemResponses?.forEach(received => {
      if(received.jobCardStatus==3){
        received.type = "labour";
        received.checked = false;
        this.quoteReceivedDetails.push(received);
        this.quoteReceivedTotal +=  (received.labourAmount*received.quantity);
        this.quoteReceivedLabourCount = this.quoteReceivedLabourCount+1;
      }
    });

    if(this.quoteReceivedDetails?.length==0){
      this.quoteReceivedSelectedTotal = 0;
      this.quoteReceivedSelectedCount = 0;
      this.quoteReceivedTotal = 0;
      this.isActiveApprove = false;
    }
    this.discountType = this.quoteDetails.discountType;
    this.discountValue = this.quoteDetails.discountValue;
    console.log("this.discountType",this.discountType);
    console.log("this.discountValue",this.discountValue);
    // dfas
  }

  getQuoteApprovedDetails(){
    this.quoteDetails?.items?.forEach(approved => {
      if(approved.jobCardStatus==4){
        approved.type = "parts";
        approved.checked = false;
        this.quoteApprovedDetails.push(approved);
        this.quoteApprovedTotal +=  (approved.sellingPrice*approved.quantity);
      }
    });

    this.quoteDetails?.labourQuoteItemResponses?.forEach(approved => {
      if(approved.jobCardStatus==4){
         approved.type = "labour";
        approved.checked = false;
        this.quoteApprovedDetails.push(approved);        
        this.quoteApprovedTotal +=  (approved.labourAmount*approved.quantity);
      }
    });
  }

  toggleSelectAllQuote() {
    this.quoteReceivedDetails.forEach(received => (received.checked = this.selectAllQuote));
    this.enableAction();
  }

  checkIndividualOption() {
    this.selectAllQuote = this.quoteReceivedDetails.every(received => received.checked);
    this.enableAction();
  }

  enableAction(){
    this.quoteReceivedSelectedTotal = 0;
    this.quoteReceivedSelectedCount = 0;
    if(this.quoteReceivedDetails?.length>0){
      this.quoteReceivedDetails.forEach(selectedData => {
        if(selectedData.checked == true){
          let price:number = 0
          if(selectedData.type=="parts"){
            price = (selectedData.sellingPrice*selectedData.quantity);
          }else{
            price = (selectedData.labourAmount*selectedData.quantity);
          }

          this.quoteReceivedSelectedTotal =  this.quoteReceivedSelectedTotal + price;
          this.quoteReceivedSelectedCount++;      
          console.log("this.quoteselectedtotal-----",this.quoteReceivedSelectedCount);  
          // --------------------------------Discount--------------------------------
          console.log("this.discountType",this.discountType);
          console.log("this.discountValue",this.discountValue);
          // discouunt type and discount values
          if (this.discountType === 'rupees') {
            this.calculatedDiscount = this.discountValue;
          } else if (this.discountType === 'percentage') {
            this.calculatedDiscount = (this.quoteReceivedTotal * this.discountValue) / 100;
          }
          console.log("this.calculatedDiscount---",this.calculatedDiscount);
// ------------------------------------------------------------------------    
        }
      });
    }
    
    if(this.quoteReceivedSelectedCount>0){
      this.isActiveApprove  = true;
    }else{
      this.isActiveApprove  = false;
    }
    this.saveExtraDiscount()
  }

  approveQuotation(){
    let customerQuoteItems: any = [];
    let labourQuoteItems: any = [];
    let jobcardId:number = 0;
    if(this.quoteReceivedDetails?.length>0){
      this.quoteReceivedDetails.forEach(selectedData => {
        if(selectedData.checked == true){
          let id:number = 0
          if(selectedData.type=="parts"){
            id = selectedData.itemId;
            customerQuoteItems.push({
                "id": id,
                "jobCardStatus": 4,
                "jobcardId": selectedData.jobcardId
            });
          }else{
            id = selectedData.labourId;
            labourQuoteItems.push({
                "labourId": id,
                "jobCardStatus": 4,
                "jobcardId": selectedData.jobcardId
            });
          }

          jobcardId = selectedData.jobcardId;
          
          
        }
      });
    }

    let param = {
      "jobcardId": jobcardId,
      "customerQuoteItems": customerQuoteItems,
      "labourQuoteItems": labourQuoteItems,
      "customerQuoteId": this.quoteId,
      "source": "web"
    }

    // console.log(param);

    this.aspQuotationDetailsService.approveQuotation(param).subscribe(
      result => {
        const res = JSON.parse(JSON.stringify(result));
        console.log(res);

        this.isPopupOpen = true;
        
      },
      error => {
        console.error('Error approving quotation:', error);
      }
    );

  }

  viewApprovedQuote(){
    this.isPopupOpen = false;
    this.getQuoteDetails();
    this.cdr.detectChanges(); 
    this.switchToTab(1);
    // this.getQuoteReceivedDetails();
  }
  hasParts(): boolean {
    return this.quoteReceivedDetails?.some(item => item.type === 'parts');
  }
  haslabour(): boolean {
    return this.quoteReceivedDetails?.some(item => item.type === 'labour');
  }
  

  switchToTab(index: number): void {
    this.activeTabIndex = index;
    if (index === 1){alert("triggering")
      this.getQuoteReceivedDetails();
    }
  }

  closeViewer(): void {
    this.isViewerOpen = false;
  }
  openViewer(index: number): void {
    this.currentIndex = index;
    this.selectedImage = this.quotationImages[this.currentIndex].url; // Correctly accessing URL
    this.isViewerOpen = true;
  }
  prevImage1(): void {
    if (this.currentIndex > 0) {
      this.currentIndex--;
      this.selectedImage = this.quotationImages[this.currentIndex].url;
    }
  }
  
  nextImage1(): void {
    if (this.currentIndex < this.quotationImages.length - 1) {
      this.currentIndex++;
      this.selectedImage = this.quotationImages[this.currentIndex].url;
    }
  }
  
  deleteImage(index: number): void {
    if (index > -1) {
      // Remove the selected image from quotationImages
      this.quotationImages.splice(index, 1);
  
      // Store remaining images in updateImage
      this.deleteUpdatedImage = [...this.quotationImages];
  
      // Close viewer if the deleted image was being viewed
      if (this.currentIndex === index) {
        this.isViewerOpen = false;
      } else if (this.currentIndex > index) {
        this.currentIndex--;
      }
  
      // Update selectedImage after deletion
      if (this.updatedImages.length > 0) {
        this.selectedImage = this.updatedImages[this.currentIndex]?.url || '';
      } else {
        this.selectedImage = '';
      }
    }
  
    console.log("Updated Images:", this.updatedImages);
    console.log("updateImage:", this.deleteUpdatedImage);
  }

  @HostListener('document:keydown', ['$event'])
  handleKeyboardEvent(event: KeyboardEvent): void {
    if (!this.isViewerOpen) return;
  
    if (event.key === 'ArrowLeft') {
      this.prevImage1();
    } else if (event.key === 'ArrowRight') {
      this.nextImage1();
    } else if (event.key === 'Escape') {
      this.closeViewer();
    }
  }


  // =============================== EXTRA DISCOUNT-BOTTOM-SHEET=======================

  openExtraDiscountBottomSheet() {
    this.showExtraDiscountBottomSheet = true;
  }

  closeExtraDiscountBottomSheet() {
    this.showExtraDiscountBottomSheet = false;
  }

  setDiscountType(type: 'rupees' | 'percentage') {
    this.discountType = type;
  }

  saveExtraDiscount() {
    if (this.discountType === 'rupees') {
      this.calculatedDiscount = this.discountValue;
    } else {
      this.calculatedDiscount = (this.quoteReceivedSelectedTotal * this.discountValue) / 100;
    }
  this.showExtraDiscountBottomSheet = false;
  }

  // saveExtraDiscount() {
  //   console.log('Extra Discount Applied:', {
  //     type: this.discountType,
  //     value: this.discountValue
  //   });
  //   this.closeExtraDiscountBottomSheet();
  // }
  toggleInfoPopup() {
    this.showInfoPopup = !this.showInfoPopup;
  }
  getDiscountAmount(): number {
    if (!this.quoteReceivedSelectedTotal) return 0;
    if (this.discountType === 'rupees') {
      return this.discountValue;
    } else {
      return (this.discountValue / 100) * this.quoteReceivedSelectedTotal;
    }
  }

  getDiscountPercentage(): number {
    if (!this.quoteReceivedSelectedTotal) return 0;
    if (this.discountType === 'percentage') {
      return this.discountValue;
    } else {
      return (this.discountValue / this.quoteReceivedSelectedTotal) * 100;
    }
  }
  calculateDiscountPreview(index: number) {
    const totalAmount = this.quoteReceivedSelectedTotal || 0;
      // Check if discountValue is greater than totalAmount
      this.isDiscountInvalid = false;
      if ((this.discountType === 'rupees' && (this.discountValue || 0) > totalAmount) ||
      (this.discountType === 'percentage' && (this.discountValue || 0) > 100)) {
    this.isDiscountInvalid = true;
    }
    if (this.discountType === 'rupees') {
      this.discountInRupees = this.discountValue || 0;
      this.discountInPercent = totalAmount
        ? (this.discountInRupees / totalAmount) * 100
        : 0;
    } else {
      this.discountInPercent = this.discountValue || 0;
      this.discountInRupees = totalAmount
        ? (this.discountInPercent / 100) * totalAmount
        : 0;
    }
  }

}
